module.exports = __webpack_public_path__ + "images/img-1pEhGDz.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/managers/63.jpg
// module id = 2021
// module chunks = 0